import { SagaIterator } from 'redux-saga';
import { call } from 'redux-saga/effects';

import { IDataSourceDetailInfo } from '~src/datasource/models/IDataSourceInfo';
import { getDatasourceDetailInfo,replaceDatasourceIdWithConnectionIdForMixedContent } from '~src/spacesPlatform/sagas/SpacesSagaHelpers';

import { IContentInfo } from '../../spacesPlatform/models/IContentInfo';
import { GeocodeDatasourceAction } from '../actions/GeocodeDatasourceAction';
import { launchGeocodingRecordDialog } from '../components/recordDialog/GeocodingRecordDialog';
import { GeocodingPermissionHelper } from '../utils/GeocodingPermissionHelper';

export function* handleGeocodeDatasourceAction(action: GeocodeDatasourceAction): SagaIterator {
  const mutatableContentInfo: IContentInfo[] = yield call(replaceDatasourceIdWithConnectionIdForMixedContent, [action.contentInfo]);
  const datasourceDetailInfo: IDataSourceDetailInfo = yield call(getDatasourceDetailInfo, mutatableContentInfo[0].id);

  yield call(openGeocodingRecordDialog, mutatableContentInfo[0], datasourceDetailInfo);
}

export function openGeocodingRecordDialog(mutatableContentInfo: IContentInfo<'datasource'>, datasourceDetailInfo: IDataSourceDetailInfo) {
  if (GeocodingPermissionHelper.isGeocodingEnabledOnSite()) {
    launchGeocodingRecordDialog({datasource: mutatableContentInfo, datasourceName: datasourceDetailInfo.name, datasourceLuid: datasourceDetailInfo.datasourceLuid || datasourceDetailInfo.luid, datasourceId: datasourceDetailInfo.id});
  }
}
